import React from "react";

// Vertical/square (icon + wordmark stacked)
const LOGO_SQUARE =
  "https://customer-assets.emergentagent.com/job_heda-smart-products/artifacts/7qipr5w5_126558.jpg";

// Horizontal lockup (icon + "HEDA PLYWOODS" wordmark side by side) — confirmed clean horizontal logo
export const LOGO_HORIZONTAL =
  "https://customer-assets.emergentagent.com/job_heda-smart-products/artifacts/ovhr180m_129516.jpg";

export function Logo({ size = 36, variant = "stacked", className = "" }) {
  // "horizontal": use the horizontal lockup image
  // "stacked": logo mark + wordmark text rendered with our display font
  // "mark": just the square logo mark
  if (variant === "horizontal") {
    return (
      <a
        href="/"
        className={`inline-flex items-center ${className}`}
        data-testid="brand-logo-link"
        style={{ mixBlendMode: "multiply" }}
      >
        <img
          src={LOGO_HORIZONTAL}
          alt="Heda Plywoods"
          style={{ height: size, width: "auto" }}
          className="object-contain"
        />
      </a>
    );
  }

  if (variant === "mark") {
    return (
      <a href="/" className={`inline-flex ${className}`} data-testid="brand-logo-link">
        <img
          src={LOGO_SQUARE}
          alt="Heda Plywoods"
          style={{ width: size, height: size }}
          className="object-contain rounded-sm"
        />
      </a>
    );
  }

  return (
    <a
      href="/"
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="brand-logo-link"
    >
      <img
        src={LOGO_SQUARE}
        alt="Heda Plywoods"
        style={{ width: size, height: size }}
        className="object-contain rounded-sm"
      />
      <div className="leading-tight">
        <div
          className="font-serif text-[#1A1A18]"
          style={{ fontSize: size * 0.55, lineHeight: 1, fontWeight: 700 }}
        >
          Hedaply
        </div>
        <div className="hed-overline" style={{ fontSize: 9 }}>
          AI Product Studio
        </div>
      </div>
    </a>
  );
}

export default Logo;
